import { React, PT } from '@gasbuddy/react';
import { Table, Icon } from 'semantic-ui-react';

export class ReferralTable extends React.Component {
  state = {}

  render() {
    const { accountId, referrals } = this.props;
    return (
      <Table basic="very" selectable style={{ fontSize: '0.9em' }}>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Referee</Table.HeaderCell>
            <Table.HeaderCell width={1}>Enrolled</Table.HeaderCell>
            <Table.HeaderCell>Discounted Tx</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {(referrals || []).map(r => (
            <Table.Row>
              <Table.Cell>
                <a href={`/identity/users/${r.referee_account_id}`}>{r.referee_account_id}</a>
              </Table.Cell>
              <Table.Cell>
                {r.referee_enrolled_at && <Icon name="checkmark" />}
              </Table.Cell>
              <Table.Cell>
                {r.referrer_discounted_transaction_id && <a href={`/payments/transaction/${accountId}/${r.referrer_discounted_transaction_id}`}>{r.referrer_discounted_transaction_id}</a>}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  }
}

ReferralTable.propTypes = {
  accountId: PT.number.isRequired,
  referrals: PT.arrayOf(PT.shape({
    referee_account_id: PT.number.isRequired,
    referee_enrolled_at: PT.string.isRequired,
    referrer_discounted_transaction_id: PT.number.isRequired,
    payment_program_id: PT.number.isRequired,
  })),
};

ReferralTable.defaultProps = {
  referrals: [],
};
